import(/* webpackMode: "eager" */ "/tmp/8de65d622e98acb/app/[locale]/error.tsx");
